import { LocalizedValue } from "@features/shared/domain";

export type NotificationItemEntity = {
  id: string;
  group: string;
  topic: string;
  content: {
    type: NotificationContentType;
    sku: string;
    productId: string;
    message: LocalizedValue;
    title: LocalizedValue;
  };
  isSeen: boolean;
  isInteracted: boolean;
  createdAt: string;
  updatedAt: string;
};

export enum NotificationContentType {
  PRODUCT_LOCK_TIME_EXPIRING = "product-lock-time-expiring",
  PRODUCT_LOCK_QUANTITY_EXPIRING = "product-lock-quantity-expiring",
  PRODUCT_LOCK_UPDATED = "product-lock-updated",
  PRODUCT_LOCK_CREATED = "product-lock-created",
  PRODUCT_LOCK_REMOVED = "product-lock-removed",
  RECOMMENDATION_CREATED = "recommendation-created",
}
